import { Link, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import MovieCard from '@/components/base/MovieCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories, hotMovies, hotTVShows, type Category } from '@/mocks/movies';

const categoryTitles: Record<string, string> = {
  action: '动作片',
  comedy: '喜剧片',
  drama: '剧情片',
  'sci-fi': '科幻片',
  horror: '恐怖片',
  romance: '爱情片',
  animation: '动画片',
  documentary: '纪录片',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'action';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentSlug]);

  const currentCategory = categories.find((c: Category) => c.slug === currentSlug);
  const categoryName = categoryTitles[currentSlug] || '动作片';

  const allContent = [...hotMovies, ...hotTVShows];

  return (
    <main>
      <Breadcrumb
        items={[
          { label: '影视分类', to: '/category/action' },
          { label: categoryName },
        ]}
      />

      <section className="w-full px-4 md:px-6 py-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {categoryName}
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              蓝光1080P在线观看 · 高清不卡流畅不缓冲 · 即点即看
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-nowrap">
            {categories.map((cat: Category) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  currentSlug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-500'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {allContent.map((item) => {
              const isMovie = 'duration' in item;
              return (
                <MovieCard
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  year={item.year}
                  rating={item.rating}
                  genre={item.genre}
                  quality={item.quality}
                  imageUrl={item.imageUrl}
                  isHot={item.isHot}
                  isNew={item.isNew}
                  linkTo={`/category/${currentSlug}`}
                />
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}